module.exports = __webpack_public_path__ + "img/stickers-3-dernieres-declarations.22d4c43c.jpg";